import { z } from 'zod';
import { BOMItemType } from '../../constants/bom-item-type.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { bomItemNameSchema, bomQuantitySchema } from './item-form.js';
import { UOM_REQUIRED_MESSAGE } from './uom-required-message.js';
import { warehouseLocationGroupIdsSchema } from './warehouse-location-group-ids-schema.js';
export const RAW_GOOD_ONLY_GROUP_MEMBER_MESSAGE = 'Only Raw Good items can join an option group.';
// typeId stays the full BOMItemType enum, not z.literal(RAW_GOOD) — a literal would make a deliberately-invalid typeId a compile error instead of isRawGoodGroupMember's runtime rejection.
// Left unrefined and shared by both consumer schemas since Zod's .extend() can't follow .refine() — each applies its own isRawGoodGroupMember check after adding its extra field.
export const bomItemGroupMemberSchema = z.object({
    partId: requiredUuidString('Part is required.', 'Invalid part selection.'),
    name: bomItemNameSchema,
    quantity: bomQuantitySchema,
    // Every group member is a Raw Good (see isRawGoodGroupMember below), which always requires a UOM.
    uomId: requiredUuidString(UOM_REQUIRED_MESSAGE, 'Invalid UOM selection.'),
    typeId: z.enum(BOMItemType, 'Invalid BOM item type.'),
    // Zero entries means universal -- visible for every warehouse at Work Order creation, not hidden from all of them.
    warehouseLocationGroupIds: warehouseLocationGroupIdsSchema.default([]),
});
// Shared so the Raw-Good-only rule can't drift between the two schemas that compose bomItemGroupMemberSchema.
export function isRawGoodGroupMember(value) {
    return value.typeId === BOMItemType.RAW_GOOD;
}
//# sourceMappingURL=item-group-member.js.map